import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postContacts = (params) => {
  return axiosClient
    .post(`/api/feedback/send-contacts`, params)
    .then((r) => r.data.data);
};
